import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';

const HANDOFF_KEY = 'cio-onboarding-agent-handoff';
const HANDOFF_MARKER = '1';

const $isLoaderShowing = atom(false);

const $didAutoStart = atom(false);

const $hasIntent = atom(false);

export function setHasAgentHandoffIntent(hasIntent: boolean): void {
  $hasIntent.set(hasIntent);
}

export function useHasAgentHandoffIntent(): boolean {
  return useStore($hasIntent);
}

export function markAgentAutoStarted(): void {
  $didAutoStart.set(true);
}

export function resetAgentAutoStarted(): void {
  $didAutoStart.set(false);
}

export function getDidAgentAutoStart(): boolean {
  return $didAutoStart.get();
}

export function useDidAgentAutoStart(): boolean {
  return useStore($didAutoStart);
}

export function setIsAgentHandoffLoaderShowing(isShowing: boolean): void {
  $isLoaderShowing.set(isShowing);
}

export function getIsAgentHandoffLoaderShowing(): boolean {
  return $isLoaderShowing.get();
}

export function useIsAgentHandoffLoaderShowing(): boolean {
  return useStore($isLoaderShowing);
}

export function storeAgentHandoff(): void {
  try {
    sessionStorage.setItem(HANDOFF_KEY, HANDOFF_MARKER);
  } catch {}
}

export function peekAgentHandoff(): boolean {
  try {
    return sessionStorage.getItem(HANDOFF_KEY) === HANDOFF_MARKER;
  } catch {
    return false;
  }
}

export function clearAgentHandoff(): void {
  try {
    sessionStorage.removeItem(HANDOFF_KEY);
  } catch {}
}
